import { FilterConfig } from "../../../models/FilterConfig";
import { LineofBusiness } from "../../../models/LineofBusinessFilterData";

export const SummaryFilterConfig: Record<LineofBusiness, FilterConfig[]> = {
  electrical: [
    {
      apiKey: "date",
      filterLabelKey: "date",
      filterValueKey: "date",
      filterName: "Date Range",
      type: "single",
      payloadValuekey: "date",
      cleanable: false,
    },
    {
      apiKey: "district",
      filterLabelKey: "District",
      filterValueKey: "District",
      filterName: "District",
      type: "single",
      payloadValuekey: "district",
      cleanable: false,
    },
    {
      apiKey: "project",
      filterLabelKey: "label",
      filterValueKey: "value",
      filterName: "Project Type",
      type: "single",
      payloadValuekey: "project",
    },
    {
      apiKey: "customer",
      filterLabelKey: "id",
      filterValueKey: "id",
      filterName: "Customers",
      type: "single",
      payloadValuekey: "customer",
    },
  ],
  plumbing: [
    {
      apiKey: "date",
      filterLabelKey: "date",
      filterValueKey: "date",
      filterName: "Date",
      type: "multi",
      payloadValuekey: "date",
      cleanable: false,
    },
    {
      apiKey: "pc",
      filterLabelKey: "PC",
      filterValueKey: "PC",
      filterName: "PC",
      type: "single",
      payloadValuekey: "pcName",
      cleanable: false,
    },
    {
      apiKey: "customer",
      filterLabelKey: "customer",
      filterValueKey: "customer",
      filterName: "Customer",
      type: "single",
      payloadValuekey: "customer",
    },
  ],
};

export const filterDefaultValues: Record<LineofBusiness, any> = {
  electrical: {
    customer: "",
    District: "Minneapolis",
    project: "Project",
  },
  plumbing: {},
};
